/* eslint-disable */
/* eslint-disable-file */
/* eslint-disable-next-line */
import axios from 'axios'
import jenks from 'turf-jenks'
const utmObj = require('utm-latlng')
const turf = require('@turf/turf')
const randomPointsOnPolygon = require('random-points-on-polygon')

export default {
  mapGrid ({ commit, state }) {
    if (state.mapObject.getLayer('grid')) {
      state.mapObject.removeLayer('gridOutline')
      state.mapObject.removeSource('gridOutline')
      state.mapObject.removeLayer('grid')
      state.mapObject.removeSource('grid')
    }
    
    // Only clear Box Sampling layers if this is NOT a Box Sampling result
    if (state.distributionModel !== 'boxSampling') {
      // Clear Box Sampling layers
      if (state.mapObject.getLayer('boxSamplingWindows')) {
        state.mapObject.removeLayer('boxSamplingWindows')
        state.mapObject.removeSource('boxSamplingWindows')
      }
      if (state.mapObject.getLayer('boxSamplingValid')) {
        state.mapObject.removeLayer('boxSamplingValid')
        state.mapObject.removeSource('boxSamplingValid')
      }
      if (state.mapObject.getLayer('boxSamplingBest')) {
        state.mapObject.removeLayer('boxSamplingBest')
        state.mapObject.removeSource('boxSamplingBest')
      }
    }
    
    // Remove any Box Sampling progress overlay (always remove this)
    const progressOverlay = state.mapObject.getContainer().querySelector('.box-sampling-progress')
    if (progressOverlay) {
      progressOverlay.remove()
    }
    state.mapObject.addLayer({
      id: 'gridOutline',
      type: 'circle',
      source: {
        type: 'geojson',
        data: state.gridGeoJson
      },
      layout: {},
      paint: {
        'circle-radius': 8,
        'circle-color': 'white'
      }
    })
    state.mapObject.addLayer({
      id: 'grid',
      type: 'circle',
      source: {
        type: 'geojson',
        data: state.gridGeoJson
      },
      layout: {},
      paint: {
        'circle-radius': 6,
        'circle-color': '#ffc107'
      }
    })
    state.mapObject.setPaintProperty('blocksLayer', 'fill-opacity', 0)
    state.mapObject.setPaintProperty('blocksLayerOutline', 'line-opacity', 0)
    state.selectedBlocks.forEach((block, i) => {
      if (state.mapObject.getLayer(block.properties.blockId)) {
        state.mapObject.removeLayer(block.properties.blockId)
        state.mapObject.removeSource(block.properties.blockId)
      }
    })
    // const gridBounds = turf.bbox(state.gridGeoJson)
    // state.mapObject.fitBounds(gridBounds, {
    //   padding: 50,
    //   animate: true
    // })
  },
  post ({ commit, state }) {
    commit('setStateProperty', { property: 'posting', value: true })
    const postName = state.post.name
    const postGeoJson = JSON.stringify(state.gridGeoJson)
    const postObject = {
      name: postName,
      createdBy: 'grid_generator',
      farmId: state.farm.id,
      geoJson: postGeoJson,
      folderId: state.folder.id
    }
    axios.post('https://api.efficientvineyard.com/post/geojson', postObject).then(response => {
      if (response.data.success) {
        commit('setStateProperty', { property: 'posting', value: false })
        commit('setAlert', { active: true, message: 'This new dataset has been added to your myEV farm!', level: 'alert-success', timeout: 4000 })
      } else {
        commit('setAlert', { active: true, message: 'There was an issue posting your grid to myEV. The dataset may have been too large. Consider downloading the grid directly and manually uploading to myEV.', level: 'alert-danger', timeout: 8000 })
      }
    }).catch(err => {
      console.log(err)
      commit('setAlert', { active: true, message: 'There was an issue posting your grid to myEV. The dataset may have been too large. Consider downloading the grid directly and manually uploading to myEV.', level: 'alert-danger', timeout: 12000 })
    })
  },
  download ({ commit, state }) {
    let fileContents = JSON.stringify(state.gridGeoJson)
    fileContents = [fileContents]
    const blob = new Blob(fileContents, { type: 'text/plain;charset=utf-8' })
    const url = window.URL || window.webkitURL
    const link = url.createObjectURL(blob)
    const a = document.createElement('a')
    a.download = state.post.name + '.geojson'
    a.href = link
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },
  reset ({ commit, state }) {
    state.mapObject.setPaintProperty('blocksLayer', 'fill-opacity', 0.8)
    state.mapObject.setPaintProperty('blocksLayerOutline', 'line-opacity', 1)
    if (state.mapObject.getLayer('datasetPreview')) {
      state.mapObject.removeLayer('datasetPreview')
      state.mapObject.removeSource('datasetPreview')
    }
    if (state.mapObject.getLayer('grid')) {
      state.mapObject.removeLayer('gridOutline')
      state.mapObject.removeSource('gridOutline')
      state.mapObject.removeLayer('grid')
      state.mapObject.removeSource('grid')
    }
    
    // Clear Box Sampling layers
    if (state.mapObject.getLayer('boxSamplingWindows')) {
      state.mapObject.removeLayer('boxSamplingWindows')
      state.mapObject.removeSource('boxSamplingWindows')
    }
    if (state.mapObject.getLayer('boxSamplingValid')) {
      state.mapObject.removeLayer('boxSamplingValid')
      state.mapObject.removeSource('boxSamplingValid')
    }
    if (state.mapObject.getLayer('boxSamplingBest')) {
      state.mapObject.removeLayer('boxSamplingBest')
      state.mapObject.removeSource('boxSamplingBest')
    }
    
    // Remove any Box Sampling progress overlay
    const progressOverlay = state.mapObject.getContainer().querySelector('.box-sampling-progress')
    if (progressOverlay) {
      progressOverlay.remove()
    }
    state.selectedBlocks.forEach((block, i) => {
      if (state.mapObject.getLayer(block.properties.blockId)) {
        state.mapObject.removeLayer(block.properties.blockId)
        state.mapObject.removeSource(block.properties.blockId)
      }
    })
    commit('setStateProperty', { property: 'dataset', value: {} })
    commit('setStateProperty', { property: 'selectedBlocks', value: [] })
    commit('setStateProperty', { property: 'gridGeoJson', value: {} })
    const blocksBounds = turf.bbox(state.blocksGeoJson)
    state.mapObject.fitBounds(blocksBounds, {
      padding: 50,
      animate: true
    })
  },
  async generateDatasetGrid ({ commit, state, dispatch }) {
    // Returns distance in meters (negative values for points inside) from a point to the edges of a polygon
    /* eslint-disable */
    function distanceToPolygon({ point, polygon }) {
      if (point && polygon) {
        if (polygon.type === "Feature") { polygon = polygon.geometry }
        let distance;
        if (polygon.type === "MultiPolygon") {
          distance = polygon.coordinates
            .map(coords => distanceToPolygon({ point, polygon: turf.polygon(coords).geometry }))
            .reduce((smallest, current) => (current < smallest ? current : smallest));
        } else {
          if (polygon.coordinates.length > 1) {
            // Has holes
            const [exteriorDistance, ...interiorDistances] = polygon.coordinates.map(coords =>
              distanceToPolygon({ point, polygon: turf.polygon([coords]).geometry })
            );
            if (exteriorDistance < 0) {
              // point is inside the exterior polygon shape
              const smallestInteriorDistance = interiorDistances.reduce(
                (smallest, current) => (current < smallest ? current : smallest)
              );
              if (smallestInteriorDistance < 0) {
                // point is inside one of the holes (therefore not actually inside this shape)
                distance = smallestInteriorDistance * -1;
              } else {
                // find which is closer, the distance to the hole or the distance to the edge of the exterior, and set that as the inner distance.
                distance = smallestInteriorDistance < exteriorDistance * -1
                  ? smallestInteriorDistance * -1
                  : exteriorDistance;
              }
            } else {
              distance = exteriorDistance;
            }
          } else {
            // The actual distance operation - on a normal, hole-less polygon (converted to meters)
            distance = turf.pointToLineDistance(point, turf.polygonToLineString(polygon)) * 1000;
            if (turf.booleanPointInPolygon(point, polygon)) {
              distance = distance * -1;
            }
          }
        }
        return distance
      }
    }
    /* eslint-enable */
    if (state.selectedBlocks.length < 1 && state.dataset.name && state.datasetHeader.length < 1) {
      commit('setAlert', { active: true, message: 'You must select blocks first and a dataset!', level: 'alert-warning', timeout: 4000 })
      return false
    }
    const withinBlocks = {
      type: 'FeatureCollection',
      features: []
    }
    const grid = {
      type: 'FeatureCollection',
      features: []
    }
    const selectedBlocksGeoJson = {
      type: 'FeatureCollection',
      features: state.selectedBlocks
    }
    const multiPolygon = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'MultiPolygon',
        coordinates: []
      }
    }
    selectedBlocksGeoJson.features.forEach(feature => {
      multiPolygon.geometry.coordinates.push(feature.geometry.coordinates)
    })
    // Filter to only within blocks and within filters
    state.datasetGeoJson.features.forEach(item => {
      const withinBlock = turf.booleanPointInPolygon(item, multiPolygon)
      if (withinBlock) {
        let withinFilters = true
        // Check filters too
        state.dataset.vizSettings.filters.forEach((filter, i) => {
          if (item.properties[filter.header] < filter.min || item.properties[filter.header] > filter.max) {
            withinFilters = false
          }
        })
        if (withinFilters) {
          withinBlocks.features.push(item)
        }
      }
    })
    // FILTER OUT EDGES OF BLOCKS
    if (state.avoidEdges) {
      for (let i = withinBlocks.features.length - 1; i >= 0; i--) {
        const point = withinBlocks.features[i]
        const polygon = multiPolygon
        const distance = distanceToPolygon({ point, polygon })
        if (distance >= -4.5) {
          withinBlocks.features.splice(i, 1)
        }
      }
    }

    // Sort by header
    withinBlocks.features.sort((a, b) => (a.properties[state.datasetHeader] > b.properties[state.datasetHeader]) ? 1 : -1)
    // Calculate the ideal point values
    const minValue = withinBlocks.features[0].properties[state.datasetHeader]
    const maxValue = withinBlocks.features[withinBlocks.features.length - 1].properties[state.datasetHeader]
    // If non-Stratified
    if (state.datasetModel === 'nonStratified') {
      if (state.distributionModel === 'random') {
        // Get Randon values within the withinBlocks geoJson
        // Shuffle features and get number of points from beginning
        grid.features = withinBlocks.features.sort(() => 0.5 - Math.random()).slice(0, state.gridCount)
      } else if (state.distributionModel === 'even') {
        // Non-Stratified Even
        const interval = (maxValue - minValue) / (state.gridCount - 1)
        const idealValues = []
        for (let i = 0; i < state.gridCount; i++) {
          const value = minValue + (interval * i)
          idealValues.push(value)
        }
        // Get closest points to those values and push to grid
        idealValues.forEach(value => {
          let finalValue = false
          for (let i = 0; i < withinBlocks.features.length; i++) {
            if (withinBlocks.features[i].properties[state.datasetHeader] > value && !finalValue) {
              const frontDiff = value - withinBlocks.features[i - 1].properties[state.datasetHeader]
              const backDiff = withinBlocks.features[i].properties[state.datasetHeader] - value
              if (frontDiff < backDiff) {
                finalValue = withinBlocks.features[i - 1]
              } else {
                finalValue = withinBlocks.features[i]
              }
            }
          }
          if (finalValue) {
            grid.features.push(finalValue)
          }
        })
        grid.features.push(withinBlocks.features[withinBlocks.features.length - 1])
      }
    } else if (state.datasetModel === 'stratified') {
      if (state.distributionModel === 'random') {
        if (state.dataset.vizSettings.zoneClassification === 'equal-interval') {
          const stopInterval = (maxValue - minValue) / state.dataset.vizSettings.zoneStops
          for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
            const start = minValue + (stopInterval * (i - 1))
            const end = minValue + (stopInterval * i)
            const zoneGeoJson = {
              type: 'FeatureCollection',
              features: []
            }
            withinBlocks.features.forEach(feature => {
              if (feature.properties[state.datasetHeader] >= start && feature.properties[state.datasetHeader] <= end) {
                zoneGeoJson.features.push(feature)
              }
            })
            // FILTER OUT EDGES OF ZONES
            if (state.avoidEdges) {
              const remainingFeatures = []
              const zonePolygon = turf.concave(zoneGeoJson, { units: 'kilometers', maxEdge: 0.004 })
              zoneGeoJson.features.forEach(zoneGeoJsonFeature => {
                const point = zoneGeoJsonFeature
                const polygon = zonePolygon
                const dist = distanceToPolygon({ point, polygon })
                if (dist <= -4.5) {
                  remainingFeatures.push(zoneGeoJsonFeature)
                }
              })
              if (remainingFeatures.length > state.pointsPerZone) {
                zoneGeoJson.features = remainingFeatures
              }
            }
            // Get Randon values within the zoneGeoJson
            // Shuffle features and get number of points from beginning
            const randomZoneFeatures = zoneGeoJson.features.sort(() => 0.5 - Math.random()).slice(0, state.pointsPerZone)
            randomZoneFeatures.forEach((randomZoneFeature, i) => {
              grid.features.push(randomZoneFeature)
            })
          }
        } else if (state.dataset.vizSettings.zoneClassification === 'jenks') {
          // Get breaks
          const jenksStops = jenks(withinBlocks, state.datasetHeader, state.dataset.vizSettings.zoneStops)
          // const stopInterval = (maxValue - minValue) / state.dataset.vizSettings.zoneStops
          for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
            const start = jenksStops[i - 1]
            const end = jenksStops[i]
            const zoneGeoJson = {
              type: 'FeatureCollection',
              features: []
            }
            withinBlocks.features.forEach(feature => {
              if (feature.properties[state.datasetHeader] >= start && feature.properties[state.datasetHeader] < end) {
                zoneGeoJson.features.push(feature)
              }
            })

            // FILTER OUT EDGES OF ZONES
            if (state.avoidEdges) {
              const remainingFeatures = []
              const zonePolygon = turf.concave(zoneGeoJson, { units: 'kilometers', maxEdge: 0.004 })
              zoneGeoJson.features.forEach(zoneGeoJsonFeature => {
                const point = zoneGeoJsonFeature
                const polygon = zonePolygon
                const dist = distanceToPolygon({ point, polygon })
                if (dist <= -4.5) {
                  remainingFeatures.push(zoneGeoJsonFeature)
                }
              })
              if (remainingFeatures.length > state.pointsPerZone) {
                zoneGeoJson.features = remainingFeatures
              }
            }
            // Get Randon values within the zoneGeoJson
            // Shuffle features and get number of points from beginning
            const randomZoneFeatures = zoneGeoJson.features.sort(() => 0.5 - Math.random()).slice(0, state.pointsPerZone)
            randomZoneFeatures.forEach((randomZoneFeature, i) => {
              grid.features.push(randomZoneFeature)
            })
          }
        }
      } else if (state.distributionModel === 'even') {
        if (state.dataset.vizSettings.zoneClassification === 'equal-interval') {
          const stopInterval = (maxValue - minValue) / state.dataset.vizSettings.zoneStops
          for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
            const start = minValue + (stopInterval * (i - 1))
            const end = minValue + (stopInterval * i)
            const zoneGeoJson = {
              type: 'FeatureCollection',
              features: []
            }
            withinBlocks.features.forEach(feature => {
              if (feature.properties[state.datasetHeader] >= start && feature.properties[state.datasetHeader] <= end) {
                zoneGeoJson.features.push(feature)
              }
            })
            // FILTER OUT EDGES OF ZONES
            if (state.avoidEdges) {
              const remainingFeatures = []
              const zonePolygon = turf.concave(zoneGeoJson, { units: 'kilometers', maxEdge: 0.004 })
              zoneGeoJson.features.forEach(zoneGeoJsonFeature => {
                const point = zoneGeoJsonFeature
                const polygon = zonePolygon
                const dist = distanceToPolygon({ point, polygon })
                if (dist <= -4.5) {
                  remainingFeatures.push(zoneGeoJsonFeature)
                }
              })
              if (remainingFeatures.length > state.pointsPerZone) {
                zoneGeoJson.features = remainingFeatures
              }
            }
            // Calculate the ideal point values
            const interval = (end - start) / (state.pointsPerZone - 1)
            const idealValues = []
            for (let i = 0; i < state.pointsPerZone; i++) {
              const value = start + (interval * i)
              idealValues.push(value)
            }
            // Get closest points to those values and push to grid
            idealValues.forEach(value => {
              let finalValue = false
              for (let i = 1; i < zoneGeoJson.features.length; i++) {
                if (zoneGeoJson.features[i].properties[state.datasetHeader] > value && !finalValue) {
                  const frontDiff = value - zoneGeoJson.features[i - 1].properties[state.datasetHeader]
                  const backDiff = zoneGeoJson.features[i].properties[state.datasetHeader] - value
                  if (frontDiff < backDiff) {
                    finalValue = zoneGeoJson.features[i - 1]
                  } else {
                    finalValue = zoneGeoJson.features[i]
                  }
                }
              }
              if (finalValue) {
                grid.features.push(finalValue)
              }
            })
            grid.features.push(zoneGeoJson.features[zoneGeoJson.features.length - 1])
          }
        } else if (state.dataset.vizSettings.zoneClassification === 'jenks') {
          // Get breaks
          const jenksStops = jenks(withinBlocks, state.datasetHeader, state.dataset.vizSettings.zoneStops)
          // const stopInterval = (maxValue - minValue) / state.dataset.vizSettings.zoneStops
          for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
            const start = jenksStops[i - 1]
            const end = jenksStops[i]
            const zoneGeoJson = {
              type: 'FeatureCollection',
              features: []
            }
            withinBlocks.features.forEach(feature => {
              if (feature.properties[state.datasetHeader] >= start && feature.properties[state.datasetHeader] < end) {
                zoneGeoJson.features.push(feature)
              }
            })
            // FILTER OUT EDGES OF ZONES
            if (state.avoidEdges) {
              const remainingFeatures = []
              const zonePolygon = turf.concave(zoneGeoJson, { units: 'kilometers', maxEdge: 0.004 })
              zoneGeoJson.features.forEach(zoneGeoJsonFeature => {
                const point = zoneGeoJsonFeature
                const polygon = zonePolygon
                const dist = distanceToPolygon({ point, polygon })
                if (dist <= -4.5) {
                  remainingFeatures.push(zoneGeoJsonFeature)
                }
              })
              if (remainingFeatures.length > state.pointsPerZone) {
                zoneGeoJson.features = remainingFeatures
              }
            }
            // Calculate the ideal point values
            const interval = (end - start) / (state.pointsPerZone - 1)
            const idealValues = []
            for (let i = 0; i < state.pointsPerZone; i++) {
              const value = start + (interval * i)
              idealValues.push(value)
            }
            // Get closest points to those values and push to grid
            idealValues.forEach(value => {
              let finalValue = false
              for (let i = 1; i < zoneGeoJson.features.length; i++) {
                if (zoneGeoJson.features[i].properties[state.datasetHeader] > value && !finalValue) {
                  const frontDiff = value - zoneGeoJson.features[i - 1].properties[state.datasetHeader]
                  const backDiff = zoneGeoJson.features[i].properties[state.datasetHeader] - value
                  if (frontDiff < backDiff) {
                    finalValue = zoneGeoJson.features[i - 1]
                  } else {
                    finalValue = zoneGeoJson.features[i]
                  }
                }
              }
              if (finalValue) {
                grid.features.push(finalValue)
              }
            })
            grid.features.push(zoneGeoJson.features[zoneGeoJson.features.length - 1])
          }
        }
      } else if (state.distributionModel === 'boxSampling') {
        // Box Sampling Implementation
        if (state.datasetModel === 'stratified') {
          // Box sampling only works with stratified data
          // Inline box sampling implementation
          const boxSamplingResult = await (async () => {
            // Box Sampling Algorithm Implementation
            const zones = []
            const zoneMeans = {}

            // Create zones based on classification method
            if (state.dataset.vizSettings.zoneClassification === 'equal-interval') {
              const stopInterval = (maxValue - minValue) / state.dataset.vizSettings.zoneStops
              for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
                const start = minValue + (stopInterval * (i - 1))
                const end = minValue + (stopInterval * i)
                zones.push({ id: i, start, end, features: [] })
              }
            } else if (state.dataset.vizSettings.zoneClassification === 'jenks') {
              // Use pre-calculated breaks from dataset visualization settings
              const jenksStops = state.dataset.vizSettings.breaks || jenks(withinBlocks, state.datasetHeader, state.dataset.vizSettings.zoneStops)
              for (let i = 1; i <= state.dataset.vizSettings.zoneStops; i++) {
                const start = jenksStops[i - 1]
                const end = jenksStops[i]
                zones.push({ id: i, start, end, features: [] })
              }
            }

            // Assign features to zones and calculate means
            withinBlocks.features.forEach(feature => {
              const value = feature.properties[state.datasetHeader]
              for (const zone of zones) {
                if (value >= zone.start && value < zone.end) {
                  zone.features.push(feature)
                  break
                }
              }
            })

            // Calculate mean values for each zone
            zones.forEach(zone => {
              if (zone.features.length > 0) {
                const sum = zone.features.reduce((acc, feature) => acc + feature.properties[state.datasetHeader], 0)
                zoneMeans[zone.id] = sum / zone.features.length
              }
            })

            console.log('Box Sampling Zones:', zones.map(z => ({
              id: z.id,
              range: `${z.start.toFixed(3)} - ${z.end.toFixed(3)}`,
              featureCount: z.features.length,
              mean: zoneMeans[z.id] ? zoneMeans[z.id].toFixed(3) : 'N/A'
            })))

            // Use existing data points as our sampling grid (much more efficient!)
            const grid = withinBlocks.features.map(feature => ({
              type: 'Feature',
              properties: feature.properties,
              geometry: feature.geometry
            }))

            console.log(`Using ${grid.length} existing data points as sampling grid`)

            // Calculate actual data point spacing to create proper grid windows
            const halfWindow = Math.floor(state.boxSamplingWindowSize / 2)

            // Find the actual spacing between data points by analyzing nearby points
            const calculateDataSpacing = () => {
              if (grid.length < 2) return 0.00003 // fallback

              // Find the minimum distance between any two points
              let minDistance = Infinity
              for (let i = 0; i < Math.min(100, grid.length); i++) {
                for (let j = i + 1; j < Math.min(100, grid.length); j++) {
                  const p1 = grid[i].geometry.coordinates
                  const p2 = grid[j].geometry.coordinates
                  const distance = Math.sqrt(
                    Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2)
                  )
                  if (distance > 0 && distance < minDistance) {
                    minDistance = distance
                  }
                }
              }
              return minDistance === Infinity ? 0.00003 : minDistance
            }

            const dataSpacing = calculateDataSpacing()
            console.log(`Estimated data point spacing: ${(dataSpacing * 111000).toFixed(1)}m`)

            // Slide window and find optimal sampling locations
            const validWindows = []
            const allWindows = [] // Store all windows for visualization
            
            // Initialize map visualization layers
            const initializeMapLayers = () => {
              const mapObject = state.mapObject
              
              // Remove existing box sampling layers
              if (mapObject.getLayer('boxSamplingWindows')) {
                mapObject.removeLayer('boxSamplingWindows')
                mapObject.removeSource('boxSamplingWindows')
              }
              if (mapObject.getLayer('boxSamplingValid')) {
                mapObject.removeLayer('boxSamplingValid')
                mapObject.removeSource('boxSamplingValid')
              }
              if (mapObject.getLayer('boxSamplingBest')) {
                mapObject.removeLayer('boxSamplingBest')
                mapObject.removeSource('boxSamplingBest')
              }

              // Initialize empty sources
              mapObject.addSource('boxSamplingWindows', {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] }
              })

              mapObject.addSource('boxSamplingValid', {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] }
              })

              // Add layers
              mapObject.addLayer({
                id: 'boxSamplingWindows',
                type: 'fill',
                source: 'boxSamplingWindows',
                paint: {
                  'fill-color': '#cccccc',
                  'fill-opacity': 0.3
                }
              })

              mapObject.addLayer({
                id: 'boxSamplingValid',
                type: 'fill',
                source: 'boxSamplingValid',
                paint: {
                  'fill-color': '#00ff00',
                  'fill-opacity': 0.4
                }
              })
            }

            // Clear any existing Box Sampling layers first
            const clearBoxSamplingLayers = () => {
              const mapObject = state.mapObject
              
              // Remove Box Sampling layers
              if (mapObject.getLayer('boxSamplingWindows')) {
                mapObject.removeLayer('boxSamplingWindows')
                mapObject.removeSource('boxSamplingWindows')
              }
              if (mapObject.getLayer('boxSamplingValid')) {
                mapObject.removeLayer('boxSamplingValid')
                mapObject.removeSource('boxSamplingValid')
              }
              if (mapObject.getLayer('boxSamplingBest')) {
                mapObject.removeLayer('boxSamplingBest')
                mapObject.removeSource('boxSamplingBest')
              }
              
              // Remove any existing progress overlay
              const progressOverlay = mapObject.getContainer().querySelector('.box-sampling-progress')
              if (progressOverlay) {
                progressOverlay.remove()
              }
            }
            
            // Clear existing layers
            clearBoxSamplingLayers()

            // Initialize the map layers
            initializeMapLayers()

            // Initialize progress tracking
            commit('setStateProperty', { property: 'loaderValue', value: 0 })
            commit('setStateProperty', { property: 'loaderMax', value: grid.length })
            
            // Add progress overlay to map
            const addMapProgressOverlay = () => {
              const mapObject = state.mapObject
              
              // Remove existing overlay if it exists
              if (mapObject.getContainer().querySelector('.box-sampling-progress')) {
                mapObject.getContainer().querySelector('.box-sampling-progress').remove()
              }
              
              // Create progress overlay
              const progressOverlay = document.createElement('div')
              progressOverlay.className = 'box-sampling-progress'
              progressOverlay.innerHTML = `
                <div class="progress-container">
                  <div class="progress-title">Box Sampling Analysis</div>
                  <div class="progress-bar">
                    <div class="progress-fill" style="width: 0%"></div>
                  </div>
                  <div class="progress-text">0 / ${grid.length} windows</div>
                </div>
              `
              
              // Add styles
              progressOverlay.style.cssText = `
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: rgba(255, 255, 255, 0.95);
                border: 2px solid #6e59c7;
                border-radius: 10px;
                padding: 20px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                z-index: 1000;
                min-width: 300px;
                text-align: center;
                font-family: Arial, sans-serif;
              `
              
              const style = document.createElement('style')
              style.textContent = `
                .box-sampling-progress .progress-container {
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                }
                .box-sampling-progress .progress-title {
                  font-size: 16px;
                  font-weight: bold;
                  color: #6e59c7;
                }
                .box-sampling-progress .progress-bar {
                  width: 100%;
                  height: 20px;
                  background: #e0e0e0;
                  border-radius: 10px;
                  overflow: hidden;
                }
                .box-sampling-progress .progress-fill {
                  height: 100%;
                  background: linear-gradient(90deg, #6e59c7, #8b7ed8);
                  transition: width 0.3s ease;
                }
                .box-sampling-progress .progress-text {
                  font-size: 14px;
                  color: #666;
                }
              `
              document.head.appendChild(style)
              
              // Add to map container
              mapObject.getContainer().appendChild(progressOverlay)
            }
            
            // Add the progress overlay
            addMapProgressOverlay()
            
            // Update progress overlay function
            const updateProgressOverlay = (current, total, validCount) => {
              const progressOverlay = state.mapObject.getContainer().querySelector('.box-sampling-progress')
              if (progressOverlay) {
                const percentage = Math.round((current / total) * 100)
                const progressFill = progressOverlay.querySelector('.progress-fill')
                const progressText = progressOverlay.querySelector('.progress-text')
                
                if (progressFill) {
                  progressFill.style.width = `${percentage}%`
                }
                if (progressText) {
                  progressText.textContent = `${current} / ${total} windows (${validCount} valid)`
                }
              }
            }

            // Real-time visualization function (moved outside the loop)
            const updateMapVisualization = () => {
              const mapObject = state.mapObject
              
              // Update invalid windows layer
              const invalidWindows = allWindows.filter(w => !w.isValid).map(window => {
                const [minX, minY, maxX, maxY] = window.bounds
                return {
                  type: 'Feature',
                  properties: {
                    isValid: window.isValid,
                    zonesCovered: window.zonesCovered,
                    totalZones: window.totalZones,
                    score: window.score,
                    featuresInWindow: window.features.length
                  },
                  geometry: {
                    type: 'Polygon',
                    coordinates: [[
                      [minX, minY],
                      [maxX, minY],
                      [maxX, maxY],
                      [minX, maxY],
                      [minX, minY]
                    ]]
                  }
                }
              })

              // Update valid windows layer
              const validWindowsForMap = allWindows.filter(w => w.isValid).map(window => {
                const [minX, minY, maxX, maxY] = window.bounds
                return {
                  type: 'Feature',
                  properties: {
                    isValid: window.isValid,
                    zonesCovered: window.zonesCovered,
                    totalZones: window.totalZones,
                    score: window.score,
                    featuresInWindow: window.features.length
                  },
                  geometry: {
                    type: 'Polygon',
                    coordinates: [[
                      [minX, minY],
                      [maxX, minY],
                      [maxX, maxY],
                      [minX, maxY],
                      [minX, minY]
                    ]]
                  }
                }
              })

              // Update map sources
              mapObject.getSource('boxSamplingWindows').setData({
                type: 'FeatureCollection',
                features: invalidWindows
              })

              mapObject.getSource('boxSamplingValid').setData({
                type: 'FeatureCollection',
                features: validWindowsForMap
              })
            }

            // Process windows in batches for real-time visualization
            const processWindowsInBatches = async () => {
              const batchSize = 100 // Process 100 windows at a time
              const totalBatches = Math.ceil(grid.length / batchSize)
              
              for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                const startIndex = batchIndex * batchSize
                const endIndex = Math.min(startIndex + batchSize, grid.length)
                
                console.log(`Processing batch ${batchIndex + 1}/${totalBatches} (windows ${startIndex + 1}-${endIndex})`)
                
                // Process this batch
                for (let index = startIndex; index < endIndex; index++) {
                  const centerPoint = grid[index]
                // Create a proper grid window around this center point
                const windowFeatures = []
                const centerX = centerPoint.geometry.coordinates[0]
                const centerY = centerPoint.geometry.coordinates[1]

                // Find all points within the grid window
                for (let dx = -halfWindow; dx <= halfWindow; dx++) {
                  for (let dy = -halfWindow; dy <= halfWindow; dy++) {
                    const targetX = centerX + (dx * dataSpacing)
                    const targetY = centerY + (dy * dataSpacing)

                    // Find the closest data point to this grid position
                    let closestPoint = null
                    let closestDistance = Infinity

                    withinBlocks.features.forEach(feature => {
                      const coords = feature.geometry.coordinates
                      const distance = Math.sqrt(
                        Math.pow(coords[0] - targetX, 2) + Math.pow(coords[1] - targetY, 2)
                      )
                      if (distance < closestDistance && distance < dataSpacing * 0.5) {
                        closestDistance = distance
                        closestPoint = feature
                      }
                    })

                    if (closestPoint) {
                      windowFeatures.push(closestPoint)
                    }
                  }
                }

                if (windowFeatures.length === 0) continue

                const zonesInWindow = new Set()
                const zoneCounts = {}

                windowFeatures.forEach(feature => {
                  const value = feature.properties[state.datasetHeader]
                  for (const zone of zones) {
                    if (value >= zone.start && value < zone.end) {
                      zonesInWindow.add(zone.id)
                      zoneCounts[zone.id] = (zoneCounts[zone.id] || 0) + 1
                      break
                    }
                  }
                })

                const zonesWithMinPixels = zones.filter(zone =>
                  zonesInWindow.has(zone.id) && zoneCounts[zone.id] >= state.minPixelsPerZone
                )

                // Require ALL zones to be present for true Box Sampling
                const minZonesRequired = zones.length
                const hasEnoughZones = zonesWithMinPixels.length >= minZonesRequired

                // Additional check: avoid edge windows (windows with very few features)
                const expectedFeatures = state.boxSamplingWindowSize * state.boxSamplingWindowSize
                // More flexible coverage for larger windows (3x3=70%, 5x5=60%, 7x7=50%)
                const coverageThreshold = state.boxSamplingWindowSize <= 3 ? 0.7 : 
                                         state.boxSamplingWindowSize <= 5 ? 0.6 : 0.5
                const hasEnoughFeatures = windowFeatures.length >= (expectedFeatures * coverageThreshold)

              // Create actual grid-based window bounds for visualization
              // Find the actual grid points that form the window
              const windowGridPoints = []
              for (let dy = -halfWindow; dy <= halfWindow; dy++) {
                for (let dx = -halfWindow; dx <= halfWindow; dx++) {
                  const targetX = centerX + (dx * dataSpacing)
                  const targetY = centerY + (dy * dataSpacing)
                  
                  // Find closest data point to this grid position
                  let closestPoint = null
                  let minDistance = Infinity
                  
                  withinBlocks.features.forEach(feature => {
                    const [x, y] = feature.geometry.coordinates
                    const distance = Math.sqrt((x - targetX) ** 2 + (y - targetY) ** 2)
                    if (distance < minDistance) {
                      minDistance = distance
                      closestPoint = feature
                    }
                  })
                  
                  if (closestPoint) {
                    windowGridPoints.push(closestPoint)
                  }
                }
              }

              // Calculate bounds from actual grid points
              const windowBounds = windowGridPoints.length > 0 ? [
                Math.min(...windowGridPoints.map(p => p.geometry.coordinates[0])),
                Math.min(...windowGridPoints.map(p => p.geometry.coordinates[1])),
                Math.max(...windowGridPoints.map(p => p.geometry.coordinates[0])),
                Math.max(...windowGridPoints.map(p => p.geometry.coordinates[1]))
              ] : [
                centerX - (halfWindow * dataSpacing),
                centerY - (halfWindow * dataSpacing),
                centerX + (halfWindow * dataSpacing),
                centerY + (halfWindow * dataSpacing)
              ]

              // Store window info for visualization
              const windowInfo = {
                center: centerPoint,
                bounds: windowBounds,
                features: windowFeatures,
                zonesCovered: zonesInWindow.size,
                totalZones: zones.length,
                isValid: false,
                score: 0
              }

              if (hasEnoughZones && hasEnoughFeatures) {
                const windowScore = windowFeatures.reduce((score, feature) => {
                  const value = feature.properties[state.datasetHeader]
                  let zoneId = null
                  for (const zone of zones) {
                    if (value >= zone.start && value < zone.end) {
                      zoneId = zone.id
                      break
                    }
                  }
                  const representativeness = zoneId && zoneMeans[zoneId] ? Math.abs(value - zoneMeans[zoneId]) : 0
                  return score + representativeness
                }, 0)

                windowInfo.isValid = true
                windowInfo.score = windowScore

                validWindows.push({
                  center: centerPoint,
                  features: windowFeatures,
                  score: windowScore,
                  zoneCounts: zoneCounts,
                  zonesCovered: zonesWithMinPixels.length,
                  totalZones: zones.length
                })
              }

              allWindows.push(windowInfo)
              }

                // Update progress and visualization after each batch
                commit('setStateProperty', { property: 'loaderValue', value: endIndex })
                updateMapVisualization()
                updateProgressOverlay(endIndex, grid.length, allWindows.filter(w => w.isValid).length)
                console.log(`Completed batch ${batchIndex + 1}/${totalBatches}: ${allWindows.filter(w => w.isValid).length} valid windows found so far`)
                
                // Allow browser to render the updated map
                await new Promise(resolve => setTimeout(resolve, 1))
              }
            }

            // Start the batch processing
            await processWindowsInBatches()

            // Reset progress when complete
            commit('setStateProperty', { property: 'loaderValue', value: 0 })
            
            // Remove only the progress overlay, keep the analysis results visible
            const progressOverlay = state.mapObject.getContainer().querySelector('.box-sampling-progress')
            if (progressOverlay) {
              progressOverlay.remove()
            }
            
            console.log('Box Sampling analysis complete! Analysis results remain visible on the map.')

            console.log(`Box Sampling: Found ${validWindows.length} valid windows out of ${grid.length} grid points`)
            console.log(`Zones: ${zones.length}, Min pixels per zone: ${state.minPixelsPerZone}, Window size: ${state.boxSamplingWindowSize}`)
            
            // Debug: Show why windows are being rejected
            if (validWindows.length === 0) {
              console.log('Debug: Analyzing why no windows were found...')
              let totalWindows = 0
              let rejectedNoFeatures = 0
              let rejectedNotEnoughFeatures = 0
              let rejectedNotEnoughZones = 0
              
              grid.slice(0, 10).forEach(centerPoint => {
                totalWindows++
                const windowFeatures = []
                const centerX = centerPoint.geometry.coordinates[0]
                const centerY = centerPoint.geometry.coordinates[1]

                for (let dx = -halfWindow; dx <= halfWindow; dx++) {
                  for (let dy = -halfWindow; dy <= halfWindow; dy++) {
                    const targetX = centerX + (dx * dataSpacing)
                    const targetY = centerY + (dy * dataSpacing)
                    
                    let closestPoint = null
                    let closestDistance = Infinity
                    
                    withinBlocks.features.forEach(feature => {
                      const coords = feature.geometry.coordinates
                      const distance = Math.sqrt(
                        Math.pow(coords[0] - targetX, 2) + Math.pow(coords[1] - targetY, 2)
                      )
                      if (distance < closestDistance && distance < dataSpacing * 0.5) {
                        closestDistance = distance
                        closestPoint = feature
                      }
                    })
                    
                    if (closestPoint) {
                      windowFeatures.push(closestPoint)
                    }
                  }
                }
                
                if (windowFeatures.length === 0) {
                  rejectedNoFeatures++
                } else {
                  const expectedFeatures = state.boxSamplingWindowSize * state.boxSamplingWindowSize
                  const hasEnoughFeatures = windowFeatures.length >= (expectedFeatures * 0.7)
                  
                  if (!hasEnoughFeatures) {
                    rejectedNotEnoughFeatures++
                  } else {
                    const zonesInWindow = new Set()
                    windowFeatures.forEach(feature => {
                      const value = feature.properties[state.datasetHeader]
                      for (const zone of zones) {
                        if (value >= zone.start && value < zone.end) {
                          zonesInWindow.add(zone.id)
                          break
                        }
                      }
                    })
                    
                    if (zonesInWindow.size < zones.length) {
                      rejectedNotEnoughZones++
                    }
                  }
                }
              })
              
              console.log(`Debug results (first 10 windows):`)
              console.log(`- Total windows tested: ${totalWindows}`)
              console.log(`- Rejected (no features): ${rejectedNoFeatures}`)
              console.log(`- Rejected (not enough features): ${rejectedNotEnoughFeatures}`)
              console.log(`- Rejected (not enough zones): ${rejectedNotEnoughZones}`)
              console.log(`- Expected features for ${state.boxSamplingWindowSize}x${state.boxSamplingWindowSize}: ${state.boxSamplingWindowSize * state.boxSamplingWindowSize}`)
              console.log(`- Required features (70%): ${Math.ceil((state.boxSamplingWindowSize * state.boxSamplingWindowSize) * 0.7)}`)
            }

            if (validWindows.length === 0) {
              console.log('No windows found with ALL zones. Trying relaxed requirements...')

              // Fallback: Try with relaxed zone requirements
              const relaxedWindows = []
              grid.forEach(centerPoint => {
                // Create a proper grid window around this center point
                const windowFeatures = []
                const centerX = centerPoint.geometry.coordinates[0]
                const centerY = centerPoint.geometry.coordinates[1]

                // Find all points within the grid window
                for (let dx = -halfWindow; dx <= halfWindow; dx++) {
                  for (let dy = -halfWindow; dy <= halfWindow; dy++) {
                    const targetX = centerX + (dx * dataSpacing)
                    const targetY = centerY + (dy * dataSpacing)

                    // Find the closest data point to this grid position
                    let closestPoint = null
                    let closestDistance = Infinity

                    withinBlocks.features.forEach(feature => {
                      const coords = feature.geometry.coordinates
                      const distance = Math.sqrt(
                        Math.pow(coords[0] - targetX, 2) + Math.pow(coords[1] - targetY, 2)
                      )
                      if (distance < closestDistance && distance < dataSpacing * 0.5) {
                        closestDistance = distance
                        closestPoint = feature
                      }
                    })

                    if (closestPoint) {
                      windowFeatures.push(closestPoint)
                    }
                  }
                }

                if (windowFeatures.length === 0) return

                const zonesInWindow = new Set()
                const zoneCounts = {}

                windowFeatures.forEach(feature => {
                  const value = feature.properties[state.datasetHeader]
                  for (const zone of zones) {
                    if (value >= zone.start && value < zone.end) {
                      zonesInWindow.add(zone.id)
                      zoneCounts[zone.id] = (zoneCounts[zone.id] || 0) + 1
                      break
                    }
                  }
                })

                // Relaxed: require at least 2 zones and enough features
                const expectedFeatures = state.boxSamplingWindowSize * state.boxSamplingWindowSize
                // More flexible coverage for larger windows (3x3=70%, 5x5=60%, 7x7=50%)
                const coverageThreshold = state.boxSamplingWindowSize <= 3 ? 0.7 : 
                                         state.boxSamplingWindowSize <= 5 ? 0.6 : 0.5
                const hasEnoughFeatures = windowFeatures.length >= (expectedFeatures * coverageThreshold)
                const hasEnoughZones = zonesInWindow.size >= 2

                if (hasEnoughZones && hasEnoughFeatures) {
                  const windowScore = windowFeatures.reduce((score, feature) => {
                    const value = feature.properties[state.datasetHeader]
                    let zoneId = null
                    for (const zone of zones) {
                      if (value >= zone.start && value < zone.end) {
                        zoneId = zone.id
                        break
                      }
                    }
                    const representativeness = zoneId && zoneMeans[zoneId] ? Math.abs(value - zoneMeans[zoneId]) : 0
                    return score + representativeness
                  }, 0)

                  relaxedWindows.push({
                    center: centerPoint,
                    features: windowFeatures,
                    score: windowScore,
                    zoneCounts: zoneCounts,
                    zonesCovered: zonesInWindow.size,
                    totalZones: zones.length
                  })
                }
              })

              if (relaxedWindows.length > 0) {
                console.log(`Found ${relaxedWindows.length} windows with relaxed requirements`)
                validWindows.push(...relaxedWindows)
              } else {
                console.log('No valid windows found even with relaxed requirements')
                return []
              }
            }

            // Sort by multiple criteria to find the truly best window
            validWindows.sort((a, b) => {
              // Primary: More zones is better
              if (a.zonesCovered !== b.zonesCovered) {
                return b.zonesCovered - a.zonesCovered
              }
              // Secondary: Lower representativeness score is better
              return a.score - b.score
            })

            // Select the SINGLE best window (Box Sampling concept)
            const bestWindow = validWindows[0]

            console.log(`Box Sampling: Selected 1 optimal window out of ${validWindows.length} valid windows`)
            const expectedFeatures = state.boxSamplingWindowSize * state.boxSamplingWindowSize
            const coveragePercent = ((bestWindow.features.length / expectedFeatures) * 100).toFixed(1)

            console.log('Best window details:', {
              score: bestWindow.score,
              zonesCovered: bestWindow.zonesCovered,
              totalZones: bestWindow.totalZones,
              featuresInWindow: bestWindow.features.length,
              expectedFeatures: expectedFeatures,
              coveragePercent: coveragePercent + '%',
              zoneCounts: bestWindow.zoneCounts,
              windowSize: state.boxSamplingWindowSize
            })

            // Debug: Show top 5 windows for comparison
            console.log('Top 5 windows:', validWindows.slice(0, 5).map(w => ({
              score: w.score,
              zonesCovered: w.zonesCovered,
              featuresInWindow: w.features.length,
              zoneCounts: w.zoneCounts
            })))

            // Return actual data points from within the SINGLE best window
            const samplingPoints = bestWindow.features.map((feature, featureIndex) => ({
              type: 'Feature',
              properties: {
                ...feature.properties,
                boxSamplingScore: bestWindow.score,
                zonesInWindow: bestWindow.zonesCovered || Object.keys(bestWindow.zoneCounts).length,
                totalZones: bestWindow.totalZones || zones.length,
                windowSize: state.boxSamplingWindowSize,
                pointInWindow: featureIndex + 1,
                totalPointsInWindow: bestWindow.features.length
              },
              geometry: feature.geometry
            }))

            console.log(`Box Sampling: Generated ${samplingPoints.length} sampling points from the single optimal window`)

            // Highlight the selected best window
            const highlightBestWindow = () => {
              const mapObject = state.mapObject
              
              // Remove existing best window layer
              if (mapObject.getLayer('boxSamplingBest')) {
                mapObject.removeLayer('boxSamplingBest')
                mapObject.removeSource('boxSamplingBest')
              }

              // Create best window rectangle using actual grid points
              const centerX = bestWindow.center.geometry.coordinates[0]
              const centerY = bestWindow.center.geometry.coordinates[1]
              
              // Find the actual grid points that form the best window
              const bestWindowGridPoints = []
              for (let dy = -halfWindow; dy <= halfWindow; dy++) {
                for (let dx = -halfWindow; dx <= halfWindow; dx++) {
                  const targetX = centerX + (dx * dataSpacing)
                  const targetY = centerY + (dy * dataSpacing)
                  
                  // Find closest data point to this grid position
                  let closestPoint = null
                  let minDistance = Infinity
                  
                  withinBlocks.features.forEach(feature => {
                    const [x, y] = feature.geometry.coordinates
                    const distance = Math.sqrt((x - targetX) ** 2 + (y - targetY) ** 2)
                    if (distance < minDistance) {
                      minDistance = distance
                      closestPoint = feature
                    }
                  })
                  
                  if (closestPoint) {
                    bestWindowGridPoints.push(closestPoint)
                  }
                }
              }

              // Calculate bounds from actual grid points
              const [minX, minY, maxX, maxY] = bestWindowGridPoints.length > 0 ? [
                Math.min(...bestWindowGridPoints.map(p => p.geometry.coordinates[0])),
                Math.min(...bestWindowGridPoints.map(p => p.geometry.coordinates[1])),
                Math.max(...bestWindowGridPoints.map(p => p.geometry.coordinates[0])),
                Math.max(...bestWindowGridPoints.map(p => p.geometry.coordinates[1]))
              ] : [
                centerX - (halfWindow * dataSpacing),
                centerY - (halfWindow * dataSpacing),
                centerX + (halfWindow * dataSpacing),
                centerY + (halfWindow * dataSpacing)
              ]

              const bestWindowFeature = {
                type: 'Feature',
                properties: {
                  score: bestWindow.score,
                  zonesCovered: bestWindow.zonesCovered,
                  totalZones: bestWindow.totalZones,
                  featuresInWindow: bestWindow.features.length
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [[
                    [minX, minY],
                    [maxX, minY],
                    [maxX, maxY],
                    [minX, maxY],
                    [minX, minY]
                  ]]
                }
              }

              // Add best window (red outline)
              mapObject.addSource('boxSamplingBest', {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features: [bestWindowFeature]
                }
              })

              mapObject.addLayer({
                id: 'boxSamplingBest',
                type: 'line',
                source: 'boxSamplingBest',
                paint: {
                  'line-color': '#ff0000',
                  'line-width': 3,
                  'line-opacity': 0.8
                }
              })

              console.log(`Highlighted best window with score: ${bestWindow.score.toFixed(3)}`)
            }

            // Highlight the best window
            highlightBestWindow()

            return samplingPoints
          })()

          if (boxSamplingResult && boxSamplingResult.length > 0) {
            grid.features = boxSamplingResult
            console.log(`Box Sampling: Successfully generated ${boxSamplingResult.length} sampling points`)
          } else {
            commit('setAlert', { active: true, message: 'Box sampling could not find valid sampling windows. The algorithm tried multiple fallback strategies but could not find windows with sufficient zone coverage. Try using a larger window size or check that your dataset has good zone distribution.', level: 'alert-warning', timeout: 8000 })
            return false
          }
        } else {
          commit('setAlert', { active: true, message: 'Box sampling requires stratified data. Please select "Stratified" option.', level: 'alert-warning', timeout: 4000 })
          return false
        }
      }
    }
    commit('setStateProperty', { property: 'gridGeoJson', value: grid })
    dispatch('mapGrid')
    // })
  },
  generateRandomGrid ({ commit, state, dispatch }) {
    if (state.selectedBlocks < 1) {
      commit('setAlert', { active: true, message: 'You must select blocks first!', level: 'alert-warning', timeout: 2000 })
      return false
    }
    const grid = {
      type: 'FeatureCollection',
      features: []
    }
    const selectedBlocksGeoJson = {
      type: 'FeatureCollection',
      features: state.selectedBlocks
    }
    const multiPolygon = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'MultiPolygon',
        coordinates: []
      }
    }
    selectedBlocksGeoJson.features.forEach(feature => {
      multiPolygon.geometry.coordinates.push(feature.geometry.coordinates)
    })
    grid.features = randomPointsOnPolygon(state.gridCount, multiPolygon)
    commit('setStateProperty', { property: 'gridGeoJson', value: grid })
    dispatch('mapGrid')
  },
  generateEvenGrid ({ commit, state, dispatch }) {
    console.log('Generate Even Grid')
    commit('setStateProperty', { property: 'loader', value: true })
    commit('setStateProperty', { property: 'loaderValue', value: 0 })
    commit('setStateProperty', { property: 'loaderMax', value: state.blocksGeoJson.features.length })
    if (state.selectedBlocks < 1) {
      commit('setAlert', { active: true, message: 'You must select blocks first!', level: 'alert-warning', timeout: 2000 })
      return false
    }
    // const grid = {
    //   type: 'FeatureCollection',
    //   features: []
    // }
    // Default Ellipsoid is 'WGS 84'
    const utm = new utmObj() // eslint-disable-line
    // Combine selected blocks
    const selectedBlocksGeoJson = {
      type: 'FeatureCollection',
      features: state.selectedBlocks
    }

    const combinedTrimmedGrid = {
      type: 'FeatureCollection',
      features: []
    }

    // START LOOP

    selectedBlocksGeoJson.features.forEach(selectedBlock => {
      console.log(selectedBlock)
      console.log(state.loaderValue)
      const loaderValue = state.loaderValue + 1
      commit('setStateProperty', { property: 'loaderValue', value: loaderValue })
      // Create bouding box around selected blocks geoJson
      const grid = {
        type: 'FeatureCollection',
        features: []
      }
      const bounds = turf.bbox(selectedBlock) // returns [ minX, minY, maxX, maxY ]
      const buffer = 0.001
      const minX = bounds[0] - buffer
      const minY = bounds[1] - buffer
      const maxX = bounds[2] + buffer
      const maxY = bounds[3] + buffer
      // Setup grid geoJson based on Universal Grid
      // Convert Bounds to UTM SW and NE
      // Output example { Easting: 464659.99600809, Northing: 1614646.6030166026, ZoneNumber: 37, ZoneLetter: "P" }
      const utmSW = utm.convertLatLngToUtm(minY, minX, 14) // 14 accuracy based on geojson.io outputs
      const utmNE = utm.convertLatLngToUtm(maxY, maxX, 14) // 14 accuracy based on geojson.io outputs
      const zoneNum = utmSW.ZoneNumber
      const zoneLetter = utmSW.ZoneLetter
      // Calculate distance to get to desired number
      let distance = state.gridDistance
      if (state.gridDistributedBy === 'count') {
        // Get blocks area
        const selectedBlocksArea = turf.area(selectedBlocksGeoJson)
        const areaPerPoint = selectedBlocksArea / state.gridCount
        distance = Math.sqrt(areaPerPoint)
        // For count based calculations, just leave the easting and northing alone
      } else if (state.gridDistributedBy === 'distance') {
        // For distance based calculations round SW up to nearest easting and northing that is a multiple of distance
        // This ensures universality of distance-based grids
        utmSW.Easting = Math.ceil(utmSW.Easting / distance) * distance
        utmSW.Northing = Math.ceil(utmSW.Northing / distance) * distance
      }
      // Round SW up to nearest easting and northing that is a multiple of distance
      // utmSW.Easting = Math.ceil(utmSW.Easting / distance) * distance
      // utmSW.Northing = Math.ceil(utmSW.Northing / distance) * distance
      // Iterate from there east until hitting the east boundary
      for (let northing = utmSW.Northing; northing < utmNE.Northing; northing = northing + distance) {
        for (let easting = utmSW.Easting; easting < utmNE.Easting; easting = easting + distance) {
          // Convert each coordinate back to Lat/Long
          const latLng = utm.convertUtmToLatLng(easting, northing, zoneNum, zoneLetter)
          // Convert
          grid.features.push({
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Point',
              coordinates: [
                latLng.lng,
                latLng.lat
              ]
            }
          })
        }
      }
      // Trim Grid Points to the polygon
      const trimmedGrid = turf.pointsWithinPolygon(grid, selectedBlocksGeoJson)
      // Push these trimmed grid points to the combinedTrimmedGrid
      trimmedGrid.features.forEach(trimmedGridFeature => {
        combinedTrimmedGrid.features.push(trimmedGridFeature)
      })
    })

    // END LOOP

    commit('setStateProperty', { property: 'gridGeoJson', value: combinedTrimmedGrid })
    dispatch('mapGrid')
    commit('setStateProperty', { property: 'loader', value: false })
    commit('setStateProperty', { property: 'loaderValue', value: 0 })
  },
  alert ({ commit, state }, message) {
    setTimeout(() => {
      commit('setStateProperty', { property: 'alert', value: message })
    }, 100)
    setTimeout(() => {
      commit('setStateProperty', { property: 'alert', value: false })
    }, 3000)
  },
  initGridMap ({ commit, state, dispatch }) {
    mapboxgl.accessToken = 'pk.eyJ1IjoibGVyZ3AiLCJhIjoiY2p4bmI1NzNzMGN0MTNjcGx4cjF4eDBtdSJ9.2C0FEHhNZ-jGd7jgIRTrEQ' // eslint-disable-line
    state.mapObject = new mapboxgl.Map({ // eslint-disable-line
      container: 'gridMap',
      // style: 'mapbox://styles/mapbox/satellite-v9',
      style: 'https://api.maptiler.com/maps/da520b6d-739a-4646-888f-1d3f2b664f78/style.json?key=IuJ0D0R9S0Cjl4krhvr1',
      center: [-95, 40],
      zoom: 3
    })

    state.mapObject.addControl(new mapboxgl.NavigationControl()) // eslint-disable-line
    // WHEN MAP LOADS SETUP BLOCKS
    state.mapObject.on('load', function () {
      // VARS
      const bounds = new mapboxgl.LngLatBounds() // eslint-disable-line
      // Get blocks geoJson File
      const blocksGeoJsonUrl = state.farm.blocksGeoJsonURL
      axios.get(blocksGeoJsonUrl).then(response => {
        state.blocksGeoJson = response.data
        // ADD LAYERS
        state.mapObject.addLayer({
          id: 'blocksLayer',
          type: 'fill',
          source: {
            type: 'geojson',
            data: state.blocksGeoJson
          },
          layout: {},
          paint: {
            'fill-color': '#6e59c7', // eslint-disable-line
            'fill-opacity': 0.8, // eslint-disable-line
          }
        })
        state.mapObject.addLayer({
          id: 'blocksLayerOutline',
          type: 'line',
          source: {
            type: 'geojson',
            data: state.blocksGeoJson
          },
          layout: {},
          paint: {
            'line-width': 2,
            'line-color': '#eee',
            'line-opacity': 1
          }
        })
        //
        //
        // CLICK EVENTS
        state.mapObject.on('click', 'blocksLayer', function (e) {
          if (!state.dataset.id) {
            const currentBlocks = state.selectedBlocks
            // Remove highlighted block layers
            currentBlocks.forEach((block, i) => {
              if (state.mapObject.getLayer(block.properties.blockId)) {
                state.mapObject.removeLayer(block.properties.blockId)
                state.mapObject.removeSource(block.properties.blockId)
              }
            })
            // Select clicked block if not already selected
            let wasSelected = false
            for (let i = currentBlocks.length - 1; i >= 0; i--) {
              if (currentBlocks[i].properties.blockId === e.features[0].properties.blockId) {
                currentBlocks.splice(i, 1)
                wasSelected = true
              }
            }
            if (!wasSelected) {
              currentBlocks.push(e.features[0])
            }
            currentBlocks.forEach((block, i) => {
              state.mapObject.addLayer({
                id: block.properties.blockId,
                type: 'fill',
                source: {
                  type: 'geojson',
                  data: block
                },
                layout: {},
                paint: {
                  'fill-color': '#ffc107', // eslint-disable-line
                  'fill-opacity': 0.8, // eslint-disable-line
                }
              })
            })
            commit('setStateProperty', { property: 'selectedBlocks', value: currentBlocks })
          }
        })
        // MANUALLY ADDING POINTS
        state.mapObject.on('click', 'datasetPreview', function (e) {
          if (state.datasetModel === 'manual') {
            const clickedPoint = e.features[0]
            let removePoint = false
            const grid = {
              type: 'FeatureCollection',
              features: []
            }
            if (state.gridGeoJson.features) {
              for (let i = state.gridGeoJson.features.length - 1; i >= 0; i--) {
                if (clickedPoint.geometry.coordinates[0] === state.gridGeoJson.features[i].geometry.coordinates[0] && clickedPoint.geometry.coordinates[1] === state.gridGeoJson.features[i].geometry.coordinates[1]) {
                  console.log('Removed Point')
                  removePoint = true
                } else {
                  grid.features.push({
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Point',
                      coordinates: state.gridGeoJson.features[i].geometry.coordinates
                    }
                  })
                }
              }
            }
            if (!removePoint) {
              grid.features.push({
                type: 'Feature',
                properties: {},
                geometry: {
                  type: 'Point',
                  coordinates: clickedPoint.geometry.coordinates
                }
              })
              commit('setStateProperty', { property: 'gridGeoJson', value: grid })
              dispatch('mapGrid')
            }
          }
        })
        // REMOVE POINTS
        state.mapObject.on('click', 'gridOutline', function (e) {
          if (state.datasetModel === 'manual') {
            const clickedPoint = e.features[0]
            // let removePoint = false
            const grid = {
              type: 'FeatureCollection',
              features: []
            }
            if (state.gridGeoJson.features) {
              for (let i = state.gridGeoJson.features.length - 1; i >= 0; i--) {
                if (clickedPoint.geometry.coordinates[0] === state.gridGeoJson.features[i].geometry.coordinates[0] && clickedPoint.geometry.coordinates[1] === state.gridGeoJson.features[i].geometry.coordinates[1]) {
                  console.log('Removed Point')
                } else {
                  grid.features.push({
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Point',
                      coordinates: state.gridGeoJson.features[i].geometry.coordinates
                    }
                  })
                }
              }
            }
            commit('setStateProperty', { property: 'gridGeoJson', value: grid })
            dispatch('mapGrid')
          }
        })
        // END CLICK EVENTS
        //
        //
        // MOUSE ENTER AND LEAVE POINTERS
        state.mapObject.on('mouseenter', 'blocksLayer', function () {
          state.mapObject.getCanvas().style.cursor = 'pointer'
        })
        state.mapObject.on('mouseleave', 'blocksLayer', function () {
          state.mapObject.getCanvas().style.cursor = ''
        })
        // BOUNDS UPDATE ONLY IF THERE ARE FEATURES
        if (state.blocksGeoJson.features.length > 0) {
          state.blocksGeoJson.features.forEach(feature => {
            feature.geometry.coordinates[0].forEach(coordinatePair => {
              bounds.extend(coordinatePair)
            })
          })
          state.mapObject.fitBounds(bounds, {
            padding: 50,
            animate: false
          })
        } else {
          const lat = state.farm.geolocation.latitude
          const lng = state.farm.geolocation.longitude
          state.mapObject.flyTo({
            center: [lng, lat],
            zoom: 15,
            animate: false
          })
        }
      }) // axios get blocksGeoJson
    }) // map.on load
  },
  initPlugin ({ commit, state, dispatch }, farmId) {
    commit('setStateProperty', { property: 'spinner', value: true })
    const timeStamp = new Date().getTime()
    const url = 'https://api.efficientvineyard.com/farm/' + farmId + '?timestamp=' + timeStamp
    axios.get(url).then(response => {
      response.data.id = farmId
      commit('setStateProperty', { property: 'farm', value: response.data })
      commit('setStateProperty', { property: 'spinner', value: false })
      dispatch('initGridMap')
      return true
    })
    // Get Root Folders
    // Get Root Datasets
  }
}
